import { BASE_SETTING_PRIORITIES } from 'api/digitalTwin/digitalTwinConstants'
import { useHasPermission } from 'helpers/global.helper/global.helper'
import {
  applySystemDisplayColors,
  getDeviationModulePriorities,
} from 'helpers/settingPriority.helper/settingPriority.helper'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from 'ui/components/AuthContext/AuthContext'

import DigitalTwinSettingsView from './DigitalTwinSettingsView'

export default function DigitalTwinDeviationSettingsView(): ReactElement | null {
  const { t } = useTranslation()
  const { activeSystem } = useAuth()

  const permissions = {
    canEdit: useHasPermission(`change_plan_settings`),
    canEditHistoric: useHasPermission(`change_historic_plan_settings`),
  }

  const systemPriorityLevels = activeSystem?.setting_priority_levels

  return (
    <DigitalTwinSettingsView
      priorities={getDeviationModulePriorities(systemPriorityLevels)}
      baseSettingPriorities={applySystemDisplayColors(BASE_SETTING_PRIORITIES, systemPriorityLevels)}
      showCalendar={true}
      title={t(`Deviation settings`)}
      calendarTitle={t(`Deviation settings - calendar`)}
      tableTitle={t(`Deviation settings - table`)}
      permissions={permissions}
    />
  )
}
